import { useSuspenseQuery } from '@tanstack/react-query'

import { useRequiredSession } from '@/contexts/auth/session/use-required-session'
import { useRequiredCompanyIdInRoute } from '@/hooks/route/use-required-company-id'
import { userQueryOptions } from '@/queries/user'

export function useUserQuery() {
  const companyId = useRequiredCompanyIdInRoute()
  const { userId } = useRequiredSession()

  return useSuspenseQuery(userQueryOptions(companyId, userId))
}
